import { UPDATE_TIME, HIDE_TIMER } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_TIME:
            return {
                ...state,
                t: action.payload,
            }
        case HIDE_TIMER:
            return {
                ...state,
                hideTimer: action.payload,
            }
        default:
            return state
    }
}
